export const isStaleTagPickerReAdd = (
  currentTagIds: readonly string[],
  nextTagIds: readonly string[],
  pendingRemovalIds: readonly string[]
): boolean => {
  if (currentTagIds.length > 0 || nextTagIds.length === 0) {
    return false;
  }

  const pendingIds = new Set(pendingRemovalIds);
  return nextTagIds.every((id) => pendingIds.has(id));
};
